import { Buffer } from 'buffer';

export const formatBaseline = (
  baselineTrace: string | undefined | null,
  baselineEnabled: boolean | undefined,
  disableTraces: boolean | undefined
) => {
  if (!baselineTrace || !baselineEnabled || disableTraces) return [];
  return Buffer.from(baselineTrace)
    .toString('utf8')
    .slice(1)
    .slice(0, -1)
    .split(',')
    .map(Number);
};
